<template>
    <ui-Airboard :panel="'login'" :openTab="false" :idView="`componet_${_uid}`" :loading="loading">
        <template v-slot:body>
            <inline-svg class="logo" :src="getImage('mysair-logo.svg')"></inline-svg>
            <div class="welcome">{{ $dicc.login.title }}</div>
            <div class="voz-alert" v-if="isGoogle()">
                By signing in, you are authorizing Google to control your devices.
            </div>
            <FormMixinInput type="text" :label="$dicc.user.email" property="email"></FormMixinInput>
            <FormMixinInput
                type="password"
                :label="$dicc.user.pass"
                property="password"
                @keyup.enter="Login"
            ></FormMixinInput>
            <a class="btn btn--simple my-3" @click.stop.prevent="Login" href>{{ $dicc.login.action }}</a>
            <template v-if="$route.name !== 'Authorize'">
                <router-link :to="{ name: 'Remember' }" class="link my-2">{{ $dicc.login.rememberAction }}</router-link>
                <hr />
                <router-link :to="{ name: 'Register' }" class="link my-2">{{ $dicc.login.registerAction }}</router-link>
                <template v-if="$config.ENV === 'local'">
                    <hr />
                    <router-link :to="{ name: 'UiComponents' }" class="link my-2">ui-components</router-link><br />
                </template>
            </template>
        </template>
    </ui-Airboard>
</template>

<style>
    .voz-alert {
        position: relative;
        left: 50%;

        margin: 1em 0;
        padding: 0.5em 1em;

        background-color: gainsboro;
        border: 0.1em gray solid;
        text-align: center;
        font-weight: bold;
    }
    @media (max-width: 767.98px) {
        .voz-alert {
            width: 100vw;
            transform: translateX(-50vw);
        }
    }
    @media (min-width: 768px) {
        .voz-alert {
            width: 50vw;
            transform: translateX(-25vw);
        }
    }
</style>

<script>
    import { FormMixin } from '../mixins/FormMixin';

    export default {
        name: 'Login',
        mixins: [FormMixin],
        data: function() {
            return {
                loading: 0,
            };
        },
        methods: {
            init() {
                this.$set(this, 'model', {
                    email: null,
                    password: null,
                });
                if (this.$config.ENV !== 'pro') {
                    this.model.email = this.$config.TEST_USER;
                    this.model.password = this.$config.TEST_PASS;
                }
            },

            Login: function() {
                this.loading++;
                this.resetErrors();

                this.$api.login(
                    this.model.email,
                    this.model.password,
                    (data) => {
                        if (this.$route.name === 'Authorize') {
                            let urlRedirect = `${this.$config.API_DOMAIN}/oauth/authorize?client_id=${this.$route.query.client_id}&redirect_uri=${this.$route.query.redirect_uri}&response_type=code&state=${this.$route.query.state}&remember_token=${data.entity.remember_token}`;
                            document.location.href = urlRedirect;
                        } else {
                            this.$session.login(data.entity);
                            this.$router.push({ name: 'Dashboard' });
                        }
                    },
                    (error) => this.showError(error, `#componet_${this._uid}`),
                    () => this.loading--
                );
            },

            isVoz() {
                return this.$route.name === 'Authorize' && this.$route.query.redirect_uri != null;
            },

            isAlexa() {
                return this.isVoz() && this.$route.query.redirect_uri.includes('amazon');
            },

            isGoogle() {
                return this.isVoz() && this.$route.query.redirect_uri.includes('google');
            },
        },
    };
</script>
